import { connect, Dispatch } from "react-redux";
import React from "react";
import { SubmissionError, formValueSelector } from "redux-form";
import { RouteProps, Redirect } from "react-router";
import Snackbar, { SnackbarContent } from "material-ui/Snackbar";
import { Grid, WithStyles, withStyles, Typography, Avatar } from "material-ui";
import Person from "material-ui-icons/Person";

/**
 * Props provided by redux
 */
interface IChatAvatarStateProps {
    name?: string;
    image?: string;
    contact?: string;
}

const styles = {
    personInfo: {
        color: "rgb(162, 162, 162)",
        padding: 20,
    },
    personName: {
        lineHeight: "36px",
        fontSize: " 28px",
        color: "#3a649e",
    },
    avatar: {
        width: 80,
        height: 80,
        marginLeft: 8,
    },
} as React.CSSProperties;

/**
 * Dispatch functions provided by redux
 */
interface IChatAvatarDispatchProps {}

/**
 * Internal state of this component
 */
interface IChatAvatarState {}
interface IChatAvatarReduxProps {}

/**
 * Combined properties of he component
 */
type IChatAvatarProps = IChatAvatarStateProps &
    IChatAvatarDispatchProps &
    RouteProps &
    WithStyles<"avatar" | "personName" | "personInfo">;

const ChatAvatar: React.SFC<IChatAvatarProps> = ({
    classes,
    ...props
}: IChatAvatarProps) => {
    const { image, name, contact } = props;
    return (
        <Grid container justify={"center"} alignItems={"center"} spacing={0}>
            <Grid item xs={3} sm={3}>
                {(props.image && (
                    <Avatar
                        alt={props.name || "Ei määritetty"}
                        src={props.image}
                        className={classes.avatar}
                    />
                )) || (
                    <Avatar className={classes.avatar}>
                        <Person
                            style={{
                                width: 80,
                                height: 80,
                                backgroundColor: "#3a649e",
                            }}
                        />
                    </Avatar>
                )}
            </Grid>
            <Grid item xs={9} sm={9}>
                <div className={classes.personInfo}>
                    <Typography variant="body1" color={"inherit"}>
                        Yhteyshenkilönne
                    </Typography>
                    <Typography
                        variant="body1"
                        color={"inherit"}
                        className={classes.personName}
                    >
                        {props.name
                            ? props.name
                            : "Au\u00ADto\u00ADmaat\u00ADti\u00ADvas\u00ADtaus"}
                    </Typography>
                    <Typography variant="body1" color={"inherit"}>
                        {" "}
                        {props.contact
                            ? props.contact
                            : "HYPO puhelinvaihde: 09-228 361"}
                    </Typography>
                </div>
            </Grid>
        </Grid>
    );
};
// const mapStateToProps = (state: ReduxState): IChatAvatarState => {
//   return {};
// };

// const mapDispatchToProps = (
//   dispatch: ReduxDispatch
//      IChatAvatarDispatchProps => {
//   return {};
// };

export default withStyles(styles)<IChatAvatarStateProps>(ChatAvatar);

// connect(mapStateToProps, mapDispatchToProps)



// WEBPACK FOOTER //
// ./src/views/messages/threadpage/components/ChatAvatar.tsx